import { ArrowDown, ArrowUp } from 'lucide-react';
import { SORT_DIRECTION_LABELS, SORT_OPTION_LABELS } from './searchSorting';
import type { SortDirection, SortOption } from './types';

/** Top-bar control showing how results are ordered as a row of field buttons — click the active field to flip its direction, click another field to switch to it. */
const SortControl = ({
  sortBy,
  direction,
  options,
  onChange,
  onToggleDirection,
}: {
  sortBy: SortOption;
  direction: SortDirection;
  options: SortOption[];
  onChange: (value: SortOption) => void;
  onToggleDirection: () => void;
}) => (
  <div className="flex items-center rounded-lg border border-gray-200 bg-white text-sm overflow-hidden">
    {options.map((option) => {
      const isActive = option === sortBy;
      return (
        <button
          key={option}
          type="button"
          onClick={() => (isActive ? onToggleDirection() : onChange(option))}
          title={isActive ? SORT_DIRECTION_LABELS[option][direction] : `Sort by ${SORT_OPTION_LABELS[option]}`}
          className={`flex items-center gap-1 px-3 py-1.5 font-medium border-r border-gray-200 last:border-r-0 focus:outline-none ${
            isActive ? 'bg-emerald-50 text-emerald-700' : 'text-gray-600 hover:bg-gray-50'
          }`}
        >
          {SORT_OPTION_LABELS[option]}
          {isActive &&
            (direction === 'desc' ? (
              <ArrowDown className="w-3.5 h-3.5" />
            ) : (
              <ArrowUp className="w-3.5 h-3.5" />
            ))}
        </button>
      );
    })}
  </div>
);

export default SortControl;
